<template>
    <div v-if="timezones.length > 0">
        <div class="row justify-content-center mb-3">
            <div class="col-md-12">
                <basic-schedule-table :timezones="timezones"/>
            </div>
        </div>

        <div class="row justify-content-center mb-3">
            <div class="col-md-12">
                <exception-schedule-table/>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import moment from 'moment-timezone'

    export default {
        data: function () {
            return {
                timezones: [],
            }
        },

        created: function () {
            this.fetchTimezones()
        },

        methods: {
            /**
             * タイムゾーン取得
             */
            fetchTimezones: function () {
                axios.get(constants.doctor.profile.endpoint.timezone)
                    .then(({data}) => {
                        const momentTimezones = moment.tz.names()
                        this.timezones = data.data.filter((d) => momentTimezones.includes(d.key))
                    })
            },
        }
    };
</script>
